module.exports = "/images/magnet-1954.jpg?b6769936b289bd514abe414433713a94";